<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ paymentTermId ? 'Update Payment Term' : 'Create Payment Term' }} </h3>
        </div>
        <div class="card-body">
          <settings-payment-terms-form
            [paymentTerm]="paymentTerm"
          />
        </div>
      </div>
    </div>
    
  </div>